import type { IVirtualAccount } from 'BreetHelpers';
import * as yup from 'yup';

export const TopupSchema = yup.object({
	amount: yup.string().required('Amount is required'),
});

export type TopupSchemaType = yup.InferType<typeof TopupSchema>;

export type TopupStatusType = 'init' | 'account-created' | 'expired';

export interface ITopupAccountDetailsProps {
	setTopupStatus?: (status: TopupStatusType) => () => void;
	amount: string;
	data?: IVirtualAccount;
}

export interface ITopupExpiredProps {
	restartTopup: () => void;
}
